import { UserType } from '../types/user.type';

export const getUser = (): UserType | undefined => {
    try {
        if (typeof window !== 'undefined') {
            const userValue = localStorage.getItem('user');
            if (userValue) {
                return JSON.parse(userValue);
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};

export const deleteUserFromStorage = (): void => {
    const storageKey = process.env.NEXT_PUBLIC_USER_STORAGE_KEY;
    try {
        if (storageKey) {
            localStorage.removeItem(storageKey);
        }
    } catch (err) {
        console.info('Local Storage is not available.');
    }
};

export const saveUserToStorage = (user: UserType) => {
    const storageKey = process.env.NEXT_PUBLIC_USER_STORAGE_KEY;
    try {
        if (storageKey) {
            localStorage.setItem(storageKey, JSON.stringify(user));
        }
    } catch (err) {
        console.info(
            'Local Storage is not available. Unable to save user state!',
        );
    }
};

export const setDeviceSyncFlag = () => {
    const deviceSyncLocalStorageKey =
        process.env.NEXT_PUBLIC_DEVICE_SYNC_STORAGE_KEY;
    try {
        if (deviceSyncLocalStorageKey) {
            localStorage.setItem(
                deviceSyncLocalStorageKey,
                JSON.stringify(true),
            );
        }
    } catch (err) {
        console.info(
            'Local Storage is not available. Wearable device synchronization skipped!',
        );
    }
};

export const getDeviceSyncFlag = (): boolean => {
    const deviceSyncLocalStorageKey =
        process.env.NEXT_PUBLIC_DEVICE_SYNC_STORAGE_KEY;
    try {
        if (deviceSyncLocalStorageKey) {
            const rawStoredValue = localStorage.getItem(
                deviceSyncLocalStorageKey,
            );
            if (rawStoredValue) {
                return JSON.parse(rawStoredValue);
            }
        }
        return false;
    } catch (err) {
        return false;
    }
};

export const deleteDeviceSyncFlag = (): void => {
    const deviceSyncLocalStorageKey =
        process.env.NEXT_PUBLIC_DEVICE_SYNC_STORAGE_KEY;
    try {
        if (deviceSyncLocalStorageKey) {
            localStorage.removeItem(deviceSyncLocalStorageKey);
        }
    } catch (err) {
        console.info('Local Storage is not available.');
    }
};
